import gameNames from '../../hub/data/GameIds';

const Constants = {
  GAME_ID: gameNames.BECAUSE_THIS_THAT,
  QUESTION_COUNT_TO_MASTER_LEVEL: 5,
  QUESTIONS_PER_ROUND: 6,

  MIN_G35_LEVEL: 6,

  // Styles and hard coded animation values
  STANDARD_SLOT_OFFSET_TO_CENTER: 40,
  INSTRUCTION_CHEV_OPACITY: 0.3,

  OPTION_BORDER_WIDTH: 5,
  BORDER_BLINK_DURATION: 600,

  // Colors
  WHITE: '#FFFFFF',
  BLUE: '#0059b3',
  RED: '#de5240',
  GREEN: '#00c1b2',
  PROGRESS_UNFILL: '#4A4A4A',
  PROGRESS_FILL: '#30A392',

  // Different Views in the Game
  GAME_VIEWS: {
    ONBOARDING: 'onboarding',
    REPEAT_ONBOARDING: 'repeat_onboarding',
    STANDARD: 'standard',
    PROGRESS: 'progress',
    LOADING: 'loading',
  },

  ONBOARDING_ANIMATION_TIME: 1000,

  // Types of content
  CONTENT_TYPES: {
    CAUSEEFFECT: 'cause-effect',
    PROBLEMSOLUTION: 'problem-solution',
  },
  CONTENT_HEADERS: {
    CAUSE: 'Cause',
    EFFECT: 'Effect',
    PROBLEM: 'Problem',
    SOLUTION: 'Solution',
  },

  // Alex states
  ALEX_STATES: {
    inactive: 0,
    active: 1,
    speaking: 2,
  },

  CHEVRON_DIMENSIONS: {
    WIDTH: 455,
    HEIGHT: 220,
  },
};

export const SLOT_IDS = {
  SUBMISSION_1: 0,
  SUBMISSION_2: 1,
  HOME_1: 2,
  HOME_2: 3,
  HOME_3: 4,
};

export const OPTIONS_IDS = {
  OPTION_1: 0,
  OPTION_2: 1,
  OPTION_3: 2,
};

export default Constants;
